// extracted by mini-css-extract-plugin
export var box = "_4d-1";
export var checkboxRow = "_4d-8";
export var checked = "_4d-2";
export var descriptionSpacer = "_4d-a";
export var disabled = "_4d-3";
export var icon = "_4d-6";
export var input = "_4d-0";
export var labelSpacer = "_4d-9";
export var medium = "_4d-5";
export var small = "_4d-4";
export var text = "_4d-7";